module.exports = __webpack_public_path__ + "static/media/img-404-tp.53080c19.gif";